export const HAS_BORDER_AT_CHECKOUT_STYLES = '';
